var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#434345;opacity:0.01;isolation:isolate;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,23.89a4,4,0,0,0-4,4V48.11a4,4,0,0,0,2,3.45L63.47,62a3.73,3.73,0,0,0,3.81-6.42L51.94,46.42V27.87A4,4,0,0,0,48,23.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.89,8.05A39.8,39.8,0,0,0,17.81,21.58V12.05a4,4,0,0,0-8,0v20a4,4,0,0,0,4,4H33.85a4,4,0,1,0,0-8h-11A32,32,0,1,1,16,51.61a4,4,0,0,0-8,.87A40.11,40.11,0,1,0,47.89,8.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.245d896a0c22cd7f1db8220504cf14c9.svg";
export { ForwardRef as ReactComponent };